module.exports = __webpack_public_path__ + "media/images/niq-publish-b0f0e7a19e24750f87d56d18a840119e.svg";